(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const menu = document.querySelector('[data-mobile-menu]');
    const openBtn = document.querySelector('[data-menu-open]');
    const closeBtn = document.querySelector('[data-menu-close]');
    if (!menu || !openBtn) return;
    let hideTimer = null;
    const open = () => {
      clearTimeout(hideTimer);
      menu.hidden = false;
      menu.getBoundingClientRect();
      menu.classList.add('is-open');
      openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('rk-menu-lock');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    };
    const close = () => {
      menu.classList.remove('is-open');
      openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('rk-menu-lock');
      openBtn.focus({ preventScroll: true });
      clearTimeout(hideTimer);
      hideTimer = setTimeout(() => { if (!menu.classList.contains('is-open')) menu.hidden = true; }, 460);
    };
    menu.addEventListener('transitionend', (e) => {
      if (e.target === menu && !menu.classList.contains('is-open')) menu.hidden = true;
    });
    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    menu.addEventListener('click', (e) => { if (e.target === menu) close(); });
    document.addEventListener('keydown', (e) => {
      if (menu.hidden) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      const f = Array.from(menu.querySelectorAll('a[href], button:not([disabled])'));
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-artwork"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const dialog = document.querySelector('[data-enquire-dialog]');
    const openBtn = document.querySelector('[data-enquire-open]');
    const closeBtn = document.querySelector('[data-enquire-close]');
    const toast = document.querySelector('[data-enquire-toast]');
    openBtn?.addEventListener('click', () => dialog?.showModal());
    closeBtn?.addEventListener('click', () => dialog?.close());
    dialog?.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
    dialog?.querySelector('[data-rk-lead-form]')?.addEventListener('rk:form:success', () => {
      setTimeout(() => dialog.close(), 600);
      if (toast) {
        toast.hidden = false;
        setTimeout(() => { toast.hidden = true; }, 4000);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.currentScript.closest('[data-pdp]');
    if (!section) return;
    const bar = section.querySelector('[data-sticky-atc]');
    const atc = section.querySelector('.pdp__atc');
    if (!bar || !atc || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      bar.hidden = entries[0].isIntersecting;
    }, { rootMargin: '0px 0px -120px 0px' });
    io.observe(atc);
    section.querySelector('[data-sticky-add]')?.addEventListener('click', () => atc.click());
  })();

  } catch(e) { console.error(e); }
})();
})();
